import React, { Component } from 'react';

class Etapa7 extends Component {
    render() {
        return (
            <div>
                <center>
                    <h1 style={{marginTop:'8%'}}>Muito obrigado! <br />Sua opnião é muito importante para nós! </h1>

                    <button type="submit" style={{marginTop:'15%'}} className="btn btn-block btn-home btn-success" onClick={() => {
                                    this.props.history.push({pathname:`/1`})
                                }}>Finalizar</button>
                </center>
            </div>
        );
    }
}

export default Etapa7;